export const DEFAULT_SUCCESS_MESSAGE_DURATION = 1;
export const DEFAULT_ERROR_MESSAGE_DURATION = 1.5;
